<template>
  <div class="level">
    <img :src="LevelData.imgUrl" alt="" 图片 />
    <div class="numbers">
      <span class="big">{{LevelData.superscript}}/</span><span class="small">{{LevelData.subscript}}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: ["LevelData"],
  data() {
    return {};
  },
};
</script>
<style scoped>
.level {
  width: 100%;
  height: 100%;
  position: relative;
}
img {
  width: 100%;
  height: 100%;
}
.numbers {
  position: absolute;
  top: 90px;
  left: 30px;
  color: #fff;
}
.big {
  font-weight: bold;
  font-size: 13px;
}
.small {
  font-size: 7.5px;
}
</style>


// WEBPACK FOOTER //
// src/components/mycom/level.vue